const localeEvents = (() => {
  const dropdownCount = 3; // Number of dropdowns
  let currentLanguageCode = null;
  const eventListeners = {}; // Object to store event listeners by dropdown index


  // Set the initial language for each dropdown
  function setInitialLanguage(dropdownIndex) {
    try {
      const urlLocale = getLanguage();
      currentLanguageCode = urlLocale;

      const languageName = defaultLocaleOptions[currentLanguageCode];
      const optionElement = document.querySelector(`.custom-option${dropdownIndex}[data-lang="${currentLanguageCode}"]`);
      const iconId = optionElement ? optionElement.getAttribute('data-icon') : null;

      if (currentLanguageCode && languageName && iconId) {
        setLocale(dropdownIndex, currentLanguageCode, languageName, iconId);
      }
    } catch (error) {
      console.error('Error setting initial language:', error);
    }
  }

  // Set the locale and update the UI
  function setLocale(dropdownIndex, languageCode, languageName, iconId) {
    try {
      const selectedText = document.getElementById(`selected-locale${dropdownIndex}`);
      const selectedIcon = document.getElementById(`selected-locale-icon${dropdownIndex}`);

      if (selectedText && selectedIcon) {
        selectedText.innerText = languageName;
        selectedIcon.innerHTML = `<svg width="16" height="16"><use href="${iconId}"></use></svg>`;

        hideSelectedOption(dropdownIndex, languageCode);

        // Save the selected language to localStorage
        if (currentLanguageCode !== languageCode) {
          currentLanguageCode = languageCode;
          setLocalStorageItem('selectedLanguage', languageCode); // Store only one selected language in localStorage
          syncSelectedLanguageWithUrl(languageCode);
          location.reload(); // Reload the page to apply the new language
        }
      }
    } catch (error) {
      console.error('Error setting locale:', error);
    }
  }

  // Function to hide the selected option from the dropdown
  function hideSelectedOption(dropdownIndex, languageCode) {
    try {
      document.querySelectorAll(`.custom-option${dropdownIndex}`).forEach(option => {
        option.classList.remove('hide-option');
      });

      const selectedOption = document.querySelector(`.custom-option${dropdownIndex}[data-lang="${languageCode}"]`);
      if (selectedOption) {
        selectedOption.classList.add('hide-option');
      }
    } catch (error) {
      console.error('Error hiding selected option:', error);
    }
  }

  // Function to select an option and update both the text and icon
  function selectOption(dropdownIndex, languageName, element) {
    try {
      const languageCode = element.getAttribute('data-lang');
      const iconId = element.getAttribute('data-icon');
      if (languageCode && iconId) {
        setLocale(dropdownIndex, languageCode, languageName, iconId);
        hideDropdown(dropdownIndex); // Close the dropdown after selecting
      }
    } catch (error) {
      console.error('Error selecting option:', error);
    }
  }

  // Function to toggle the dropdown
  function toggleDropdown(dropdownIndex) {
    try {
      const container = document.getElementById(`custom-locale${dropdownIndex}`);
      const options = document.getElementById(`custom-locale-options${dropdownIndex}`);
      if (!container || !options) return;

      const isVisible = !options.classList.contains('hidden'); // Check if the dropdown is visible using 'hidden' class

      if (isVisible) {
        hideDropdown(dropdownIndex); // Close the dropdown if it's already open
      } else {
        closeAllDropdowns(); // Close all other dropdowns before opening the new one
        showDropdown(dropdownIndex); // Open the current dropdown
      }
    } catch (error) {
      console.error('Error toggling dropdown:', error);
    }
  }

  // Function to show the dropdown
  function showDropdown(dropdownIndex) {
    const container = document.getElementById(`custom-locale${dropdownIndex}`);
    const options = document.getElementById(`custom-locale-options${dropdownIndex}`);

    if (container && options) {
      options.classList.remove('hidden');
      container.classList.add('dropdown-open');
      addOutsideClickListener(dropdownIndex);
    }
  }

  // Function to close all dropdowns
  function closeAllDropdowns() {
    for (let i = 1; i <= dropdownCount; i++) {
      hideDropdown(i);
    }
  }

  // Function to hide the dropdown
  function hideDropdown(dropdownIndex) {
    const container = document.getElementById(`custom-locale${dropdownIndex}`);
    const options = document.getElementById(`custom-locale-options${dropdownIndex}`);

    if (container && options && !options.classList.contains('hidden')) {
      options.classList.add('hidden');
      container.classList.remove('dropdown-open');
      removeOutsideClickListener(dropdownIndex);
    }
  }

  // Function to add the event listener for outside clicks
  function addOutsideClickListener(dropdownIndex) {
    const listener = eventListeners[dropdownIndex];

    removeOutsideClickListener(dropdownIndex); // Remove existing listener before adding a new one

    const newListener = event => handleOutsideClick(event, dropdownIndex);
    document.addEventListener('click', newListener, true);
    eventListeners[dropdownIndex] = newListener;
  }

  // Function to remove the event listener for outside clicks
  function removeOutsideClickListener(dropdownIndex) {
    const listener = eventListeners[dropdownIndex];
    if (listener) {
      document.removeEventListener('click', listener, true);
      delete eventListeners[dropdownIndex];
    }
  }

  // Function to handle outside clicks
  function handleOutsideClick(event, dropdownIndex) {
    const container = document.getElementById(`custom-locale${dropdownIndex}`);
    const dropdownOptions = document.getElementById(`custom-locale-options${dropdownIndex}`);

    if (container && dropdownOptions) {
      if (!container.contains(event.target) && !dropdownOptions.contains(event.target)) {
        hideDropdown(dropdownIndex);
      }
    }
  }

  async function localeEventsInit(){
    // Initialize the dropdown for each set of IDs
    for (let i = 1; i <= dropdownCount; i++) {
      const button = document.getElementById(`custom-locale-button${i}`);
      if (button) {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          toggleDropdown(i)
        });
        setInitialLanguage(i); // Set the initial language for this dropdown
      }
    }
  }

  function unload() {
    try {
      // Loop through all dropdown indices
      for (let i = 1; i <= dropdownCount; i++) {
        // Remove event listener for dropdown button
        const button = document.getElementById(`custom-locale-button${i}`);
        if (button) {
          button.replaceWith(button.cloneNode(true)); // Cloning removes all attached event listeners
        }

        // Remove event listener for outside click
        removeOutsideClickListener(i);

        // Clear eventListeners object
      Object.keys(eventListeners).forEach((key) => {
        delete eventListeners[key];
      });


       // Remove all children of dropdown elements
       const container = document.getElementById(`custom-locale${i}`);
       const options = document.getElementById(`custom-locale-options${i}`);
       const selectedText = document.getElementById(`selected-locale${i}`);
       const selectedIcon = document.getElementById(`selected-locale-icon${i}`);

       if (container) {
           while (container.firstChild) {
               container.firstChild.remove(); // Remove each child node
           }
       }

       if (options) {
           while (options.firstChild) {
               options.firstChild.remove(); // Remove each child node
           }
       }

       if (selectedText) {
           while (selectedText.firstChild) {
               selectedText.firstChild.remove(); // Remove each child node
           }
       }

       if (selectedIcon) {
           while (selectedIcon.firstChild) {
               selectedIcon.firstChild.remove(); // Remove each child node
           }
       }
      }
    } catch (error) {
      console.error('Error during unload:', error);
    }
  }

  return {
    toggleDropdown,
    selectOption,
    hideDropdown,
    handleOutsideClick,
    localeEventsInit,
    unload
  };
});


export { localeEvents };
